import styles from './pdfHeader.module.css'
import { useSystemState } from '../../../../modules/system'
import { Labels, useDataTypesHooks } from '../../../data-types'
import { EmptyImgImg } from '../../constants'
import { addressHelpers } from '../../../address'
import { FiscalDocumentType } from '../../../../modules/fiscal-documents'

type Props = {
    taxInfo?: boolean
    noValidTicketLabel?: boolean
    fiscalDocumentType?: FiscalDocumentType
}

export const PDFHeader = (props: Props) => {
    const { taxInfo, noValidTicketLabel, fiscalDocumentType = FiscalDocumentType.INVOICE } = props

    const { company, companyLogoUrl } = useSystemState()

    const { describeAddress } = addressHelpers
    const { formatCuitOrCuil } = useDataTypesHooks()

    const rightClassName = `${styles.right} ${!noValidTicketLabel ? styles.wide : ''}`

    return (
        <>
            <div className={styles.row}>
                <div className={styles.left}>
                    <img src={companyLogoUrl || EmptyImgImg} className={styles.img} />
                    <span className={styles.title}>
                        {company!.name}
                    </span>
                </div>
                {noValidTicketLabel && (
                    <div className={styles.noValidTicket}>
                        <span className={styles.noValidTicketX}>X</span>
                        <div className={styles.noValidTicketText}>
                            NO Válido como {Labels.fiscalDocumentTypeLabel(fiscalDocumentType)}
                        </div>
                    </div>
                )}
                <div className={rightClassName}>
                    <span>{company!.legalName}</span>
                    <span>{describeAddress(company!.address)}</span>
                    <span>{formatCuitOrCuil(company!.taxIds.find(t => t.main)!.taxId)}</span>
                    {taxInfo && (
                        <span>Cond. IVA: {Labels.vatConditionLabel(company!.vatCondition)}</span>
                    )}
                    {taxInfo && company!.grossIncomeCode && (
                        <span>N° Inscripción IIBB: {company!.grossIncomeCode}</span>
                    )}
                </div>
            </div>

            <div className={styles.separator} />
        </>
    )
}
